// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"488":"axiom","532":"styles","592":"common","736":"vendor"}[chunkId] || chunkId) + "." + {"241":"a2e8b50de08ace05dd66","488":"eff8336ee8954d9b0681","532":"8bbf4a81c065a9b9699d","592":"504c11b61ba10a47203c","736":"c68b62ec406b529aec71"}[chunkId] + ".js";
};